
import api from '../../../services/api/';
const URL = '/customers';

class CustomerService {

   getListFiltersCustomer(params){                            
         return api.get(`${URL}${params}`);
    }

    createCustomer(customer){
        return api.post(`${URL}`, customer);
    }

    getCustomerById(idCustomer){
        return api.get(idCustomer == -1 || idCustomer == null || idCustomer == undefined 
          ? `${URL}/new` 
          : `${URL}/${idCustomer}`);
    }


    updateCustomer( idCustomer, customer){
        return api.put(`${URL}/${idCustomer}`, customer);
        
    }

    deleteCustomer(idCustomer){
        return api.delete(`${URL}/${idCustomer}`);
    }

    getCustomerBySearch(str){
        return api.get(`${URL}/search?query=` + str);
    }


   getUniqueContactNames(str){
       return api.get(`${URL}/unique_contact_names`);
   }
   getUniqueEmailNames(str){
       return api.get(`${URL}/unique_email_names`);
   }

   getBusinessSizes(){
      return api.get('/business_sizes');
   }

   getBusinessTypes(){
      return api.get('/business_types');
   }

   //  addBilling(idCustomer,data){
   //    return api.put(URL + 'addBilling/' + idCustomer, data);
   // }    
   //  addShipping(idCustomer,data){
   //    return api.put(URL + 'addShipping/'+ idCustomer, data);
   // } 
   
   getCustomerBillingBySearch(str){
      return api.get(`${URL}/clientBillingSearch/` + str);
  } 

   getCustomerBillingByIdClient(idCustomer){
         return api.get(`${URL}/all_billing_accounts/` + idCustomer);
   }

   addExistingBilling(data){
      return api.post(`${URL}/add_existing_billing`, data);
   }

   updateBilling(idCustomer,data){
      return api.put(`${URL}/updateBilling/` + idCustomer, data);
   }   
   updateShipping(idCustomer,data){
      return api.put(`${URL}/updateShipping/` + idCustomer, data);
   }   

    removeBilling(idCustomer){
        return api.post(`${URL}/removeBilling`, idCustomer);
    }
    removeShipping(idCustomer){
        return api.post(`${URL}/removeShipping`, idCustomer);
    }



    getInvoices(data){    
        const  params = [];
      //   if( data.idClient != undefined && data.idClient != null )
      //   {
      //      params.push( "idClient=" + data.idClient );
      //   }        
        if( data.listPageIndex != undefined && data.listPageIndex != null )
         {
            params.push( "listPageIndex=" + data.listPageIndex );
         }
         if( data.listPerPage != undefined && data.listPerPage != null )
         {
            params.push( "listPerPage=" + data.listPerPage );
         }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.listSearch != undefined && data.listSearch != null )
         {
            params.push( "listSearch=" + data.listSearch );
         } 
         if( data.listFilters != undefined && data.listFilters != null )
         {
            params.push( "listFilters=" + JSON.stringify(data.listFilters));
         }                 
         if( data.isDeleted != undefined && data.isDeleted != null )
         {
            params.push( "isDeleted=" + data.isDeleted );
         }  
         if( data.generateType != undefined && data.generateType != null )
         {
            params.push( "generateType=" + data.generateType );
         }                                   
        return api.get('/customers/getInvoices' + (params.length ? '?' + params.join('&') : '' ));
    }

    // Portal Management API Methods
    enablePortalAccess(customerId, data) {
        return api.post(`${URL}/customer_portals/` + customerId + '/enable', data);
    }

    disablePortalAccess(customerId) {
        return api.post(`${URL}/customer_portals/` + customerId + '/disable');
    }

    updatePortalAccess(customerId, data) {
        return api.put(`${URL}/customer_portals/` + customerId, data);
    }

    checkPortalEmailAvailability(email, excludeCustomerPublicId) {
        return api.get(`${URL}/customer_portals/portal_email_availability`, {
            params: {
                email,
                exclude_customer_public_id: excludeCustomerPublicId || undefined,
            },
        });
    }

    resetPortalPassword(customerId) {
        return api.post(`${URL}/customer_portals/` + customerId + '/reset_password');
    }

    getPortalStats() {
        return api.get(`${URL}/customer_portals/stats`);
    }

    getCustomerActiveNote(customerId) {
        return api.get(`${URL}/` + customerId + '/customer_notes/active');
    }

    getCustomerNotes(customerId) {
        return api.get(`${URL}/` + customerId + '/customer_notes');
    }

    addCustomerNote(customerId, payload) {
        return api.post(`${URL}/` + customerId + '/customer_notes', payload);
    }

    deleteCustomerNote(customerId, noteId) {
        return api.delete(`${URL}/` + customerId + '/customer_notes/' + noteId);
    }
}

export default new CustomerService()